import React from "react";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import Owners from "./Owners";
import Editor from "./Editor";

export default () => {
    const {path} = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}`} exact component={Editor}></Route>
            <Route path={`${path}/owners`} exact component={Owners}></Route>
        </Switch>
    );
}
